import {
  Create,
  Datagrid,
  DateField,
  Edit,
  ImageField,
  List,
  NumberField,
  NumberInput,
  Resource,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput
} from 'react-admin';
import { FilterSidebar } from '../components/FilterSidebar';
import { ImageInput } from '../components/ImageInput';
import gql from 'graphql-tag';

export const name = 'Device';
export const fragments = {
  type: 'document',
  doc: gql`
    fragment FragDevices on devices {
      id
      bleUuid
      iconImageUrl
      name
      order
      createdAt
      updatedAt
      _count {
        exercises
        users
        userProfiles
        workouts
        __typename
      }
      __typename
    }
  `
};

const list = () => (
  <List aside={<FilterSidebar />} sort={{ field: 'name', order: 'ASC' }}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="bleUuid" />
      <NumberField source="order" />
      <ImageField source="iconImageUrl" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);

const show = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <NumberField source="order" />
      <TextField source="bleUuid" />
      <ImageField source="iconImageUrl" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);

const edit = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="name" />
      <NumberInput source="order" />
      <TextInput source="bleUuid" />
      <ImageInput source="iconImageUrl" />
    </SimpleForm>
  </Edit>
);

const create = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" />
      <NumberInput source="order" />
      <TextInput source="bleUuid" />
      <ImageInput source="iconImageUrl" create />
    </SimpleForm>
  </Create>
);

export default function AdminResource(props) {
  return (
    <Resource
      create={create}
      edit={edit}
      list={list}
      name={name}
      show={show}
      {...props}
    />
  );
}
